import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery, legacyBaseQuery } from 'commons/src/api/baseQuery';
import { DeviceType, VirtualDevicesResponse } from 'commons/src/models/commonTypeScript';
import { AddZoneGroupPayload } from '../models/common';

export const virtualDevicesApi = createApi({
    reducerPath: 'virtualDevicesApi',
    baseQuery,
    tagTypes: ['VirtualDevices'],
    endpoints: builder => ({
        getVirtualDevices: builder.query<DeviceType[], string>({
            query: buildingId => ({
                url: `/locations/${buildingId}/devices`,
                method: 'GET',
            }),
            transformResponse: (response: VirtualDevicesResponse) => {
                return response.devices;
            },
            providesTags: ['VirtualDevices'],
        }),
    }),
});

export const virtualDevicesMutationApi = createApi({
    reducerPath: 'virtualDevicesMutationApi',
    baseQuery: legacyBaseQuery,
    tagTypes: ['VirtualDevices', 'Locations'],
    endpoints: builder => ({
        addGroup: builder.mutation<void, { payload: AddZoneGroupPayload; locationId: string }>({
            query: ({ payload, locationId }) => ({
                url: `/location/${locationId}/virtualdevices`,
                method: 'POST',
                data: { ...payload, roomName: payload.segmentName },
            }),
            invalidatesTags: (result, error, { locationId }) => [{ type: 'VirtualDevices', id: locationId }], // Change to VirtualDevices
        }),
    }),
});

export const { useGetVirtualDevicesQuery } = virtualDevicesApi;
export const { useAddGroupMutation } = virtualDevicesMutationApi;

export type GetVirtualDevicesResult = ReturnType<typeof useGetVirtualDevicesQuery>;
